import type { ReactNode } from "react";

import styles from "./count-badge.module.css";

export interface CountBadgeProps {
  /** Usually a number (`zones.length`); `ReactNode` so a caller may pass an
   *  already-formatted string (e.g. `"99+"`) without this component owning
   *  that policy. */
  count: ReactNode;
  "data-test-role"?: string;
}

/** A small neutral pill for a numeric count next to a label — see
 *  `count-badge.module.css` for why this is not `Badge` with a new tone. */
function CountBadge({ count, "data-test-role": testRole }: CountBadgeProps) {
  return (
    <span className={styles.countBadge} data-test-role={testRole}>
      {count}
    </span>
  );
}

export default CountBadge;
